import type { MessageDescriptor } from 'react-intl';

export enum CountryUIConfigName {
  // Feature that enables or disables the shipping supplies link
  ShippingSuppliesLinkEnabled = 'ShippingSuppliesLinkEnabled',

  // Feature that defines the preferred carrier for sorting in carrier groups
  PreferredCarrier = 'PreferredCarrier',

  // Feature that defines the preferred provider for sorting in provider groups
  PreferredProvider = 'PreferredProvider',

  // Feature that defines the order of walleted providers
  PreferredWalletedProvidersIds = 'PreferredWalletedProvidersIds',

  // Feature that defines which todo cards should be hidden in the FTU wizard
  FTUWizardHiddenTodoCards = 'FTUWizardHiddenTodoCards',

  // Feature that defines default values for the rate browser/rate shopper
  RateBrowserDefaults = 'RateBrowserDefaults',

  // Feature to define if the rate browser requires a wallet registration to be used
  RequiresWalletForRateBrowser = 'RequiresWalletForRateBrowser',

  // Feature that enables the upgrade plan promotional banner for free plan users
  ShowsUpgradePlanPromotionalBanner = 'ShowsUpgradePlanPromotionalBanner',

  // Temporary override to hide tax ID features when enableExpandedTaxIdCountries flag is OFF
  // TODO: [SPD-26173] Remove once enableExpandedTaxIdCountries is fully rolled out
  TaxIdUIOverride = 'TaxIdUIOverride',

  // Country-specific tax information message shown to sellers
  TaxInformationMessage = 'TaxInformationMessage',

  // Feature that always shows the DDP import duties warning tooltip
  ShowsDdpImportDutiesWarning = 'ShowsDdpImportDutiesWarning',
}

export enum CountryUIProperty {
  CarrierId = 'carrierId',
}

export type TaxInformationMessageData = {
  message: MessageDescriptor;
};
